import { Repair } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface RepairInput {
  vehicle_id: number;
  client_provider_id?: number | null;
  odometer?: number | null;
  invoice_number: string | null;
  repair_date: string;
  amount: number;
  description: string;
}

export const repairService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<Repair>>("/vehicle_repair", {
      params: {
        page,
        per_page,
        search,
        ...filters,
      },
    });
    return response.data;
  },

  async create(data: RepairInput) {
    const response = await api.post("/vehicle_repair", data);
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<Repair, false>>(
      `/vehicle_repair/${id}`,
    );
    return response.data;
  },

  async update(id: string | number, data: RepairInput) {
    const response = await api.put(`/vehicle_repair/${id}`, data);
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/vehicle_repair/${id}`);
    return response.data;
  },
};
